import React from "react";

function Number({ 
    item, 
    onChange 
}) {
    return (
        <div
            className="flex-grow-1"
            style={{ paddingBottom: '4px' }}
        >
            {onChange ? (
                <>
                    <label className="form-label">{item.name}</label>
                    <input
                        type="number"
                        name="value"
                        value={item.value ?? item.payload?.value ?? 0}
                        onChange={onChange}
                        className="form-control"
                        placeholder={`${item.payload?.value} ${item.payload?.unit}`}
                    />
                </>
            ) : (
                <div className="d-flex justify-content-between">
                    <span>{item.name}</span>
                    <div className="d-flex gap-1">
                        <span>{item.value}</span>
                        {item.payload?.unit && (
                            <span>{item.payload.unit}</span>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Number;